import React from 'react';

const About = () => {
    return (
        <div>
            <h1>关于我们</h1>
            <p>我们是一家致力于提供优质产品和服务的公司。</p>
            <p>我们的使命是通过创新和卓越的客户服务来满足客户的需求。</p>
        </div>
    );
};

export default About;